import React from "react";
import { auth } from "./fbase";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useUser } from "./UserContext"; // 1. UserContext에서 useUser 훅 가져오기
import { menuConfig } from "./MenuConfig"; // 2. 메뉴 설정 가져오기

const MyNav = () => {
  const { user } = useUser(); // 3. 현재 사용자 정보 가져오기

  const onClickSignOut = async (event) => {
    event.preventDefault();
    try {
      await auth.signOut();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <header>
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Container>
          <Navbar.Brand as={Link} to="/">사귐의교회 웹지기</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/">Home</Nav.Link>

              {/* 4. 동적 메뉴 렌더링 */}
              {menuConfig
                .filter(menu => {
                  // user가 없으면 공개 메뉴만, 있으면 역할에 맞는 메뉴 필터링
                  if (!user) return !menu.roles;
                  return !menu.roles || menu.roles.includes(user.role);
                })
                .map(menu => (
                  <NavDropdown title={menu.title} id={menu.id} key={menu.id}>
                    {menu.items.map(item => (
                      <NavDropdown.Item as={Link} to={item.href} key={item.eventKey}>
                        {item.text}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                ))}
            </Nav>

            {/* 5. 로그인 상태에 따른 UI 변경 */}
            {user ? (
              <Nav>
                <Navbar.Text className="me-3">{user.email}</Navbar.Text>
                <Nav.Link href="#" onClick={onClickSignOut}>Sign out</Nav.Link>
              </Nav>
            ) : (
              <Nav>
                <Nav.Link as={Link} to="/login">Login</Nav.Link>
              </Nav>
            )}

          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default MyNav;